const routes = [
    {
        path: "/customer/credit/cards",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "customercreditcard_index"
        }
    }
];

export default routes;
